import bouttimeLogo from "../../assets/bouttime-logo.svg";

export default function WelcomeScreen({ onGetStarted, onGoToSignIn, appTheme }) {
  return (
    <div style={{
      height: "100dvh",
      boxSizing: "border-box",
      overflow: "hidden",
      background: appTheme.pageBackground,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "28vh 24px 44px",
    }}>

      {/* Logo mark + tagline — anchored to upper third */}
      <div style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
      }}>
        <img src={bouttimeLogo} alt="BoutTime" style={{ width: "148px", height: "auto" }} />
        <div style={{
          fontFamily: appTheme.fontBody,
          fontSize: "18px",
          color: "rgba(45, 90, 61, 0.6)",
          fontWeight: "400",
          marginTop: "-8px",
        }}>
          Small changes, big differences.
        </div>
      </div>

      {/* CTAs pinned to bottom */}
      <div style={{ width: "100%", maxWidth: "400px", display: "flex", flexDirection: "column", gap: "16px" }}>
        <button
          onClick={onGetStarted}
          style={{
            width: "100%",
            padding: "16px",
            borderRadius: "14px",
            border: "none",
            background: appTheme.accentColor,
            color: "#fff",
            fontFamily: appTheme.fontBody,
            fontWeight: "700",
            fontSize: "16px",
            cursor: "pointer",
            touchAction: "manipulation",
          }}
        >
          Get started
        </button>
        <p style={{
          margin: 0,
          textAlign: "center",
          fontFamily: appTheme.fontBody,
          fontSize: "14px",
          color: appTheme.secondaryText,
        }}>
          Already have an account?{" "}
          <button
            onClick={() => onGoToSignIn()}
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              color: appTheme.accentColor,
              fontFamily: appTheme.fontBody,
              fontWeight: "700",
              fontSize: "14px",
              padding: 0,
              touchAction: "manipulation",
            }}
          >
            Sign in
          </button>
        </p>
      </div>
    </div>
  );
}
